exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\nEssential imports for the global theme, but also to be used in single components\n**/\n.vs-carousel {\n  padding: 0px 60px;\n}\n.attachment-gallery__button {\n  border: 0;\n  background: none;\n}\n.attachment-gallery__button:disabled {\n  opacity: 0;\n}\n.attachment-gallery__button:hover {\n  color: #0a7074;\n}\n.attachment-gallery__image {\n  height: 80%;\n  max-width: 80%;\n}", ""]);

// exports
